export default {
  label: {
    series: 'Ratings',
  },
};
